import React from 'react';

import { TableRow, TableRowFull, TableLink } from 'components/Table';
import { INTEGRATION_USER, CALIX_SUPPORT_USER_LABEL, NOT_APPLICABLE_LABEL } from 'utils/constants';

const ResultRow = ({ item }) => {
  return (
    <React.Fragment>
      <TableRow>
        <td>
          <div>
            <TableLink to={{ pathname: `/case/${item.caseNumber}` }}>{item.caseNumber}</TableLink>
          </div>
        </td>
        <td>
          <div>{item.rmaNumber || NOT_APPLICABLE_LABEL}</div>
        </td>
        <td>
          <div>{item.contactName}</div>
        </td>
        <td>
          <div>{item.owner === INTEGRATION_USER ? CALIX_SUPPORT_USER_LABEL : item.owner}</div>
        </td>
        <td>
          <div>{item.currencyCode}</div>
        </td>
        <td>
          <div>{item.status}</div>
        </td>
      </TableRow>
      <TableRowFull>
        <td colSpan="5">
          {item.resolutionSummary && <div>Resolution Summary: {item.resolutionSummary}</div>}
          {item.createdDate && (
            <div>Created Date: {new Date(item.createdDate).toLocaleDateString()}</div>
          )}
          {item.lastModifiedDate && (
            <div>Last Modified Date: {new Date(item.lastModifiedDate).toLocaleDateString()} </div>
          )}
        </td>
      </TableRowFull>
    </React.Fragment>
  );
};

export { ResultRow };
